<template>
  <section id="content" ref="companiesContent">
    <PageTitle :title="$t('admin_companies.title')"></PageTitle>
    <div class="wrapper wrapper-content animated fadeInRight">

      <div class="row generate-success">
        <div class="col-lg-12">

          <ListCompanies></ListCompanies>

        </div>
      </div>

    </div>
  </section>
</template>

<style scoped>
  .clients-list thead{
    display:none;
  }
</style>


<script lang="ts">
import { Ref, defineComponent, PropType, computed, onMounted, onBeforeUnmount, ref, watch, reactive, ComputedRef } from '@fwk-node-modules/vue'
import { getApp, useRouter, useStore } from '@fwk-client/utils/vue-3-migration';

import { enableIbox, disableIbox} from '@root/src/client/theme/inspinia-jquery'; 

import { useGenericPage } from '@fwk-client/composables/useGenericPage';

import PageTitle from '@root/src/client/components/panels/PageTitle.vue';
import ListCompanies from '../../panels/admin/ListCompanies.vue';

export default defineComponent({
  props: {
  },
  components: {
    PageTitle,
    ListCompanies
  },
  setup(props, context) {
    const app = getApp();
    const $router = useRouter();
    const $store = useStore();

    const genericPage = useGenericPage(props, context);

    const companiesContent:Ref<HTMLElement|null> = ref(null);

    onMounted(() => {
      enableIbox(companiesContent.value!);
    })

    onBeforeUnmount(() => {
      disableIbox(companiesContent.value!);
    })

    return {
      companiesContent
    }
  }
});
</script>